module.exports = __webpack_public_path__ + "static/media/autoicon.47c19a29.png";